import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { registerDebitAutomaticComp } from "../actions";

export const handleCreateObj = (props) => {
  const obj = {
    CodigoBanco: 0,
    Agencia: 0,
    Conta: 0,
    Digito: "",
    Cotas: [
    ],
    CotasUnicas: [
    ]
  }

  props.debitsSelectedValue.forEach(item => {
    obj.CotasUnicas.push(item.IdItem)
  })
  props.registerDebitAutomaticComp(obj)
}

const mapStateToProps = store => ({
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ registerDebitAutomaticComp }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(handleCreateObj);